import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ palette }: Theme) => ({
  root: {
    color: palette.primary.main,
    zIndex: 1,
  },
}));
